import React,{useState} from 'react';
import autorImage from '../../../assets/img/forum-imgs/forum-user1.svg';
import arowFunction from '../../../assets/img/forum-imgs/arrow.svg';
import colapceArrow from '../../../assets/img/forum-imgs/arrow-inverted.svg';
const ForumDatas = () => {
    const [ selected, setSelected ] = useState(0 );
    const toggle = index =>{
        if( index === index ){
            setSelected(null)
        }
        setSelected(index)
    }
    const forumFakeData = [
        {
            forumTitle: 'Laravel Forum',
            innerForumData : [
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
            ]
        },
        {
            forumTitle: 'Php Forum',
            innerForumData : [
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
            ]
        },
        {
            forumTitle: 'React Js Forum',
            innerForumData : [
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
            ]
        },
        {
            forumTitle: 'Mern Stack Forum',
            innerForumData : [
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
                { 
                    innerTitle: 'Suspendisse id lorem',
                    innerDesc: 'Class aptent taciti sociosqu ad',
                    postNumber: '568 Posts',
                    authorImage: autorImage,
                    authorDesc: 'Praesent sagittis ...',
                    authorName: 'Richa Lee',
                    postDate: 'Sun at 11.36 pm'
                },
            ]
        }
    ];


    return (
        <div className="row gap-3">
            {
                forumFakeData.map( (item , index) =>  <div className="col-12" key={index}>
                <div className="card" style={{background: "#272727", borderRadius: "15px"}}>
                    <div className="card-body">
                        <div className="row px-2">
                            <div className="col-8"><span className="f_atxt">{item.forumTitle}</span></div>
                            <div className="col-4 text-end" >
                                <img src={ selected === index ?   colapceArrow :arowFunction  } alt='' className='cursor-pointer'  onClick={ () => toggle(index)} />
                            </div>
                        </div>
                    </div>
                    <div className={selected === index ?`w-100 d-block`: `d-none`} style={{height: "4px", background: "linear-gradient(90deg, #B402F6, #40EEFE)"}}></div>

                    {
                      selected === index && item.innerForumData.map(( item, i ) => <div key={i}> <div className="card-body gap-2" style={{backgroundColor: "#1A1A1A", borderTop: "1px solid #393939"}} >
                       <div className="row px-2">
                           <div className="col-12 col-lg-6 d-flex align-items-center mb-3 mb-lg-0">
                               <div className="d-grid">
                                   <span className="f_htxt">Suspendisse id lorem</span>
                                   <span className="txt_hbd">Class aptent taciti sociosqu ad</span>
                               </div>
                           </div>
                           <div className="col-2 col-lg-1 d-grid justify-content-center align-items-center">
                               <div className="d-grid">
                                   <span className="d-flex justify-content-center align-items-center" style={{fontSize: "20px", fontFamily: "Roboto, sans-serif", fontWeight: "400", color: "rgb(255,255,255)"}}>568</span>
                                   <span style={{fontSize: "15px", fontFamily: "Roboto, sans-serif", fontWeight: "300", color: "rgb(255,255,255)"}}>posts</span>
                               </div>
                           </div>
                           <div className="col-10 col-lg-5 d-flex align-items-center justify-content-start">
                               <img className="me-2" src={autorImage} alt='' /> 
                               <div>
                                   <div><span className="txt_name">Praesent sagittis ...</span></div>
                                   <div><span className="l_lstxt">By</span><span className="l_untxt">&nbsp;Richa Lee</span><span className="l_lstxt">, Sun at 11.36 pm</span></div>
                               </div>
                           </div>
                       </div>
                   </div>
                       
                       </div>
                       )
                    }
                   {/* <div className="w-100" style={{height: "1px", background: ""}}>
                   </div>
                    
                    <div className="card-body gap-2" style={{backgroundColor: "#1A1A1A"}}>
                        <div className="row px-2">
                            <div className="col-12 col-lg-6 d-flex align-items-center">
                                <div className="d-grid"><span className="f_htxt">Suspendisse id lorem</span><span className="txt_hbd">Class aptent taciti sociosqu ad</span></div>
                            </div>
                            <div className="col-12 col-lg-1 d-grid justify-content-center align-items-center">
                                <div className="d-grid"><span className="d-flex justify-content-center align-items-center" style={{fontSize: "20px", fontFamily: "Roboto, sans-serif", fontWeight: "400", color: "rgb(255,255,255)"}}>568</span><span style={{fontSize: "15px", fontFamily: "Roboto, sans-serif", fontWeight: "300", color: "rgb(255,255,255)"}}>posts</span></div>
                            </div>
                            <div className="col-12 col-lg-5 d-flex align-items-center justify-content-start">
                                <img className="me-2" src={autorImage} alt='' />
                                <div>
                                    <div><span className="txt_name">Praesent sagittis ...</span></div>
                                    <div><span className="l_lstxt">By</span><span className="l_untxt">&nbsp;Richa Lee</span><span className="l_lstxt">, Sun at 11.36 pm</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-100" style={{height: "1px", background: "#393939"}}></div>
                    <div className="card-body gap-2" style={{backgroundColor: "#1A1A1A"}}>
                        <div className="row px-2">
                            <div className="col-12 col-lg-6 d-flex align-items-center">
                                <div className="d-grid"><span className="f_htxt">Suspendisse id lorem</span><span className="txt_hbd">Class aptent taciti sociosqu ad</span></div>
                            </div>
                            <div className="col-12 col-lg-1 d-grid justify-content-center align-items-center">
                                <div className="d-grid"><span className="d-flex justify-content-center align-items-center" style={{fontSize: "20px", fontFamily: "Roboto, sans-serif", fontWeight: "400", color: "rgb(255,255,255)"}}>568</span><span style={{fontSize: "15px", fontFamily: "Roboto, sans-serif", fontWeight: "300", color: "rgb(255,255,255)"}}>posts</span></div>
                            </div>
                            <div className="col-12 col-lg-5 d-flex align-items-center justify-content-start">
                                <img className="me-2" src={autorImage} alt='' />
                                <div>
                                    <div><span className="txt_name">Praesent sagittis ...</span></div>
                                    <div><span className="l_lstxt">By</span><span className="l_untxt">&nbsp;Richa Lee</span><span className="l_lstxt">, Sun at 11.36 pm</span></div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>)
            }
        </div>
    );
};

export default ForumDatas;